import React from "react";

function Pill({ variant = "none", children }) {
  return <span className={`pill pill-${variant}`}>{children}</span>;
}

export default Pill;
